import dynamic      from "next/dynamic";
import { useState } from "react";

const Presentation       = dynamic ( () => import ( "./presentation" ) );
const PresentationMobile = dynamic ( () => import ( "./presentationMobile" ) );

const component = props => {

	const isMobile = props?.isMobile;

	const [ modal, setModal ] = useState ( false );

	const toggleModal = () => {
		if ( props?.dateRange === "all" )
			return;
		setModal ( prev => !prev );
	};

	if ( isMobile )
		return (
			<PresentationMobile
				{ ...props }
				modal       = { modal }
				toggleModal = { toggleModal }
			/>
		);

	return (
		<Presentation
			{ ...props }
		/>
	);
};

export default component;